import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs from "dayjs"
import { WorkflowDashboardState } from "lib/types/state"
import {
  FAILED_WORKFLOW_WINDOW_DAYS,
  failedWorkflowWindowStart
} from "helpers/failedWorkflowWindow"

const initialState: WorkflowDashboardState = {
  filteredDays: FAILED_WORKFLOW_WINDOW_DAYS,
  startDate: failedWorkflowWindowStart().format("YYYY-MM-DDTHH:mm"),
  endDate: dayjs().format("YYYY-MM-DDTHH:mm")
}

export const slice = createSlice({
  name: "workflowDashboard",
  initialState: { ...initialState },
  reducers: {
    reset: () => ({ ...initialState }),
    setFilteredDays(state, action: PayloadAction<number>) {
      state.filteredDays = action.payload
    },
    setStartDate(state, action: PayloadAction<string>) {
      state.startDate = action.payload
    },
    setEndDate(state, action: PayloadAction<string>) {
      state.endDate = action.payload
    }
  }
})

export const { reset, setFilteredDays, setStartDate, setEndDate } = slice.actions

export default slice.reducer
